// src/api/healthSurvey.js
import api from "./client";

const BASE = "/health/survey/parq";

export async function getMyParq() {
    try {
        return await api(`${BASE}/me`);
    } catch (e) {
        if (e.status === 404) return null; // 없으면 신규 입력
        throw e;
    }
}

export function createParq(payload) {
    return api(`${BASE}`, { method: "POST", body: payload });
}

export function updateParq(payload) {
    return api(`${BASE}`, { method: "PATCH", body: payload });
}

export function deleteParq() {
    return api(`${BASE}`, { method: "DELETE" });
}
